import React from "react";
import days from "dayjs";
import { Typography, Divider, Tag } from "antd";
import { getUser } from "../../../../utils/getUser";
import { getProtocolDisplayLabel } from "../../../../utils/protocolDisplayLabel";

const { Title } = Typography;

export default function DescripcionProtocolo({ itemProtocol, users, causes }) {
  const formatDate = (date) => {
    return date ? days(date).format("MMM DD, YYYY hh:mm:ss A") : "Sin fecha";
  };

  const estadoFiltros = {
    Created: "Creado",
    Started: "Iniciado",
    Completed: "Completado",
    FalseAlarm: "Falsa alarma",
    Skipped: "Saltada",
  };

  const ajusteArray = (data) => {
    const sortedData = data.sort((a, b) => {
      const orderA = parseFloat(a.order);
      const orderB = parseFloat(b.order);

      // Comparar los valores como números
      return orderA - orderB;
    });

    return sortedData;
  };

  const ordenActividades = ajusteArray(itemProtocol.activities);
  const protocolLabel = getProtocolDisplayLabel(itemProtocol?.protocol, causes);

  return (
    <div className="pdf-content">
      <div className="pdf-section">
        <Title level={4} className="pdf-title">
          {`PARP ${protocolLabel} - (${itemProtocol?.eventId})`}
        </Title>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "8px",
            fontSize: "10px",
          }}
        >
          <strong>Estado de Protocolo:</strong>
          {itemProtocol.state === "Created" && (
            <Tag key={itemProtocol.state} color="yellow" size="small">
              {estadoFiltros[itemProtocol.state]}
            </Tag>
          )}
          {itemProtocol.state === "FalseAlarm" && (
            <Tag key={itemProtocol.state} color="red" size="small">
              {estadoFiltros[itemProtocol.state]}
            </Tag>
          )}
          {itemProtocol.state === "Completed" && (
            <Tag key={itemProtocol.state} color="green" size="small">
              {estadoFiltros[itemProtocol.state]}
            </Tag>
          )}
          {itemProtocol.state === "Started" && (
            <Tag key={itemProtocol.state} color="blue" size="small">
              {estadoFiltros[itemProtocol.state]}
            </Tag>
          )}
          {itemProtocol.state === "Skipped" && (
            <Tag key={itemProtocol.state} color="blue" size="small">
              {estadoFiltros[itemProtocol.state]}
            </Tag>
          )}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "10px",
            marginBottom: "6px",
          }}
        >
          <div>
            <strong>Inicio: </strong>{" "}
            {formatDate(itemProtocol?.stateHistory?.Created?.date) || ""}
          </div>
          <div>
            <strong>Cierre: </strong>{" "}
            {formatDate(
              itemProtocol?.stateHistory?.Completed?.date ||
                itemProtocol?.stateHistory?.FalseAlarm?.date ||
                itemProtocol?.stateHistory?.Skipped?.date
            ) || "sin fecha"}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "10px",
            marginBottom: "12px",
          }}
        >
          <div>
            <strong>Usuario inicio: </strong>
            {getUser(itemProtocol.stateHistory.Created.userId, users)}
          </div>
          <div>
            <strong>Usuario cierre: </strong>
            {getUser(
              itemProtocol?.stateHistory?.Completed?.userId ||
                itemProtocol?.stateHistory?.FalseAlarm?.userId,
              users
            )}
          </div>
        </div>
      </div>

      <Divider style={{ margin: "12px 0" }} />

      <div className="pdf-section">
        <Title level={4} className="pdf-title">
          Actividades
        </Title>

        <div className="pdf-activities-container">
          {ordenActividades.map((objeto, index) => (
            <div
              key={index}
              className="pdf-activity-item"
              style={{
                marginBottom: "8px",
                padding: "6px",
                border: "1px solid #e8e8e8",
                borderRadius: "3px",
                backgroundColor: "#fafafa",
                pageBreakInside: "auto", // Permitir cortes dentro de actividades
                breakInside: "auto", // Compatibilidad con navegadores modernos
                orphans: 2, // Mínimo 2 líneas al inicio de página
                widows: 2, // Mínimo 2 líneas al final de página
              }}
            >
              <ActividadesPdf itemActividad={objeto} users={users} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const ActividadesPdf = ({ itemActividad, users }) => {
  const formatDate = (date) => {
    return date ? days(date).format("MMM DD, YYYY hh:mm:ss A") : "Sin fecha";
  };

  function obtenerDatoMasReciente(arrayDeObjetos) {
    const arrayOrdenado = arrayDeObjetos
      .slice()
      .sort((a, b) => new Date(b.date) - new Date(a.date));
    return arrayOrdenado[0];
  }

  const estadoFiltros = {
    Created: "Creado",
    Started: "Iniciado",
    Completed: "Completado",
    FalseAlarm: "Falsa alarma",
    Skipped: "Saltada",
  };

  return (
    <div
      className="pdf-activity-content"
      style={{
        fontSize: "10px",
        pageBreakInside: "auto", // Permitir cortes dentro del contenido de actividad
        breakInside: "auto", // Compatibilidad con navegadores modernos
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "6px",
          pageBreakInside: "avoid", // Evitar cortar el header de la actividad
          breakInside: "avoid", // Compatibilidad con navegadores modernos
        }}
      >
        <Title
          level={5}
          style={{
            fontSize: "11px",
            fontWeight: "bold",
            color: "#2c5aa0",
            margin: 0,
          }}
        >
          {itemActividad.protocol_activity_subactivity
            .split("_")[1]
            .replace(/-/g, " ")}
        </Title>
        <Tag color="green" size="small">
          {estadoFiltros[itemActividad.state]}
        </Tag>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "6px",
          fontSize: "9px",
          pageBreakInside: "avoid", // Evitar cortar la información de fechas
          breakInside: "avoid", // Compatibilidad con navegadores modernos
        }}
      >
        <div>
          <strong>Inicio: </strong>{" "}
          {formatDate(itemActividad?.stateHistory?.Created?.date) || ""}
        </div>
        <div>
          <strong>Cierre: </strong>{" "}
          {formatDate(
            itemActividad?.stateHistory?.Completed?.date ||
              itemActividad?.stateHistory?.FalseAlarm?.date
          ) || "sin fecha"}
        </div>
      </div>

      <div
        style={{
          marginBottom: "6px",
          textAlign: "justify",
          fontSize: "9px",
          pageBreakInside: "auto", // Permitir cortar comentarios largos
          breakInside: "auto", // Compatibilidad con navegadores modernos
        }}
      >
        <strong>Comentario: </strong>
        {itemActividad.comments.length !== 0 ? (
          <>
            {obtenerDatoMasReciente(itemActividad.comments).comment ||
              "Sin descripción"}
          </>
        ) : (
          "Sin descripción"
        )}
      </div>

      <div
        style={{
          fontSize: "9px",
          fontStyle: "italic",
          pageBreakInside: "avoid", // Evitar cortar la información del usuario
          breakInside: "avoid", // Compatibilidad con navegadores modernos
        }}
      >
        <strong>Usuario: </strong>
        {getUser(
          itemActividad?.stateHistory?.Completed?.userId ||
            itemActividad?.stateHistory?.Skipped?.userId,
          users
        )}
      </div>
    </div>
  );
};
